import { runtimeEnv } from "config/runtimeEnv";
import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import axios from 'axios';
import { tripDutyTypeEnum } from "utils/enumObj";
import { applyTenantHeader } from "./Request";

let env = runtimeEnv("B2B_API_BASE_URL");
let mapKey = runtimeEnv("GOOGLE_API_KEY");

const requestInstance = axios.create({
  baseURL: env,
});

requestInstance.interceptors.request.use(applyTenantHeader);

export const autocompleteApi = async (data) => {
  let url = '';
  if(data?.dutyType === tripDutyTypeEnum?.outstationRoundTrip && data?.locationType === "drop") {
    url = `${env}${API_ENDPOINT.GoogleMap.autocompleteApi}?name=${data?.name}&location=${data?.location}`;
  }
  else {
    url = `${env}${API_ENDPOINT.GoogleMap.autocompleteApi}?name=${data?.name}&location=${data?.cityLatitude},${data?.cityLangitude}`;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const placeApi = async (data) => {
  let url = `${env}${API_ENDPOINT.GoogleMap.placeApi}?placeId=${data?.placeId}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const directionApi = async (data) => {
  let url = `${env}${API_ENDPOINT.GoogleMap.directionApi}?destLat=${data?.destination?.lat}&destLng=${data?.destination?.lng}&orgLat=${data?.origin?.lat}&orgLng=${data?.origin?.lng}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};


export const geocodeApi = async (data) => {
  let url = `${env}${API_ENDPOINT.GoogleMap.geocodeApi}?latlng=${data?.latlng}&key=${mapKey}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};